<template>
  <div>
    <span><strong>Clip Created From : </strong><a :href="original_storage_link">{{ rowProperties.old.name }}</a></span><br>
    <span><strong>New Storage Asset : </strong><a :href="new_storage_link">{{ rowProperties.attributes.name }}</a></span><br>
  </div>
</template>

<script>
import PropertiesMixin from "VueMixins/ActivityLog/PropertiesMixin";

export default {
  mixins: [PropertiesMixin],
  props: {
    rowProperties: {
      type: Object,
      required: true,
    },
  },
  computed: {
    original_storage_link() {
      return `storage/${this.rowProperties.old.uuid}/edit`;
    },
    new_storage_link() {
      return `storage/${this.rowProperties.attributes.uuid}/edit`;
    },
  },
};
</script>
